import { DialogContent as MuiDialogContent, styled } from '@mui/material'

export const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  overflowX: 'hidden',
  [theme.breakpoints.down('md')]: {
    padding: 0
  }
}))
